import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "data/brands/actions";

import MenuLink from "components/Navigation/MenuLink";

import ActionDelete from "material-ui/svg-icons/action/delete";

import { Page, RightDrawer, PageBlock } from "components/Page";

import Subheader from "material-ui/Subheader";
import TextField from "material-ui/TextField";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow
} from "material-ui/Table";
import ClickableRowColumn from "components/Grid/ClickableRowColumn";
import ClickableRow from "components/Grid/ClickableRow";

import RaisedButton from "material-ui/RaisedButton";
import ContentAdd from "material-ui/svg-icons/content/add";
import * as os from "osutil";

class BrandPage extends Component {
  state = { selected: [] };

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.fetchBrands();
  }

  handleDeleteClick = id => {
    this.props.deleteBrand(id);
  };

  handleEditClick = id => {
    this.context.router.history.push("/admin/brand/" + id);
  };

  addBrand = e => {
    this.props.createBrand({ name: "New brand" }, this.handleEditClick);
  };

  deleteBrands = e => {
    _.each(this.state.selected, p => this.props.deleteBrand(p.key));
  };

  onRowSelection = (list, rows) => {
    var selected = rows.map(i => list[i]).filter(r => !!r);
    this.setState({ selected: selected });
  };

  onSearchChange = (event, value) => {
    var state = { ...this.state, selected: [], search: value };
    this.setState(state);
  };

  isSelected = (key) => {
    return this.state.selected.filter( b => b.key === key ).length > 0;
  };

  renderBrands(visible_brands) {
    return _.map(visible_brands, (brand) => {
      return (
        <ClickableRow
          key={brand.key}
          onMyRowClick={() => this.handleEditClick(brand.key)}
          selected={this.isSelected(brand.key)}
        >
          <ClickableRowColumn>{brand.name}</ClickableRowColumn>
          <ClickableRowColumn>{brand.description}</ClickableRowColumn>
          <ClickableRowColumn>{brand.url}</ClickableRowColumn>
        </ClickableRow>
      );
    });
  }
  render() {
    var visible_brands = _.filter(this.props.brands, brand => {
      if (this.state.search && this.state.search.length > 0) {
        if (
          brand.name.toLowerCase().indexOf(this.state.search.toLowerCase()) ===
          -1
        ) {
          return false;
        }
      }
      return true;
    });

    return [
      <RightDrawer key="right">
        <PageBlock label="Medier">
          <h4>Verktyg</h4>
          <RaisedButton onClick={this.addBrand}>Skapa ny</RaisedButton>
          <h4>Filter</h4>
          <TextField
            name="search"
            onChange={this.onSearchChange}
            floatingLabelText="Sök medier"
          />
          
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
      {/* onRowSelection={this.onRowSelection.bind(null, visible_brands)} */}
        <Table  >
          <TableHeader displaySelectAll={false} >
            <TableRow>
              <TableHeaderColumn>Namn</TableHeaderColumn>
              <TableHeaderColumn>Beskrivning</TableHeaderColumn>
              <TableHeaderColumn>URL</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} >
            {this.renderBrands(visible_brands)}
          </TableBody>
        </Table>
      </Page>
    ];
  }
}

function mapStateToProps(state) {
  return {
    brands: os.collection_to_array(state.brands.list.data),
    pending: state.brands.list.pending
  };
}

export default connect(mapStateToProps, actions)(BrandPage);



// WEBPACK FOOTER //
// ./src/pages/admin/brands/BrandsTablePage.jsx